import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { SelectServiceComponent } from './select-service/select-service.component';
import { SelectBaqComponent } from './select-baq/select-baq.component';
import { SelectEfxComponent } from './select-efx/select-efx.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'select-baq/:version',
    component: SelectBaqComponent
  },
  {
    path: 'select-baq/:version/:companyId/:baq',
    component: SelectBaqComponent
  },
  {
    path: 'select-efx/:version',
    component: SelectEfxComponent
  },
  {
    path: 'select-efx/:version/:companyId/:efx',
    component: SelectEfxComponent
  },
  {
    path: 'select-service/:version/:type/:service',
    component: SelectServiceComponent
  },
  {
    path: 'select-service/:version/:type/:service/:method',
    component: SelectServiceComponent
  },
  { path: '**', component: HomeComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
